import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import Typography from "../Typography/Typography";

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const questionsAndAnswers = [
        {
            question: "Athena ha un buon rapporto qualità prezzo?",
            answer:
                "Assolutamente sì! Athena ti permette di risparmiare tempo e stress, garantendoti una tesi perfetta in pochi passaggi. Il prezzo è accessibile a tutti e ti permette di avere un supporto costante durante tutto il percorso. Provalo e non te ne pentirai!",
        },
        {
            question: "Come posso disdire l'abbonamento?",
            answer:
                "Puoi disdire in qualsiasi momento, direttamente dalla tua area personale. Non ci sono penali, basta un semplice clic e il pagamento si interromperà subito.",
        },
        {
            question: "Come può Athena aiutarmi nella fase di ricerca per la tesi?",
            answer:
                "Athena offre un motore di ricerca avanzata che sfrutta l'AI per aiutarti a trovare articoli scientifici, banche dati e risorse utili per la tua ricerca. In pochi minuti, potrai accedere a materiali di alta qualità per il tuo lavoro.",
        },
        {
            question: "Posso generare un indice per la mia tesi con Athena?",
            answer:
                "Sì, con Athena puoi generare un indice personalizzato per la tua tesi in base al contenuto che hai selezionato. Il sistema ti guida nella creazione di una struttura coerente per il tuo lavoro.",
        },
        {
            question: "Cos'è la roadmap personalizzata di Athena?",
            answer:
                "La roadmap è una pianificazione personalizzata che ti aiuta a organizzare il tuo tempo durante la scrittura della tesi. Imposta obiettivi settimanali, traccia i progressi e affronta la procrastinazione con suggerimenti mirati.",
        },
        {
            question: "Athena offre supporto per la scrittura della tesi?",
            answer:
                "Athena non solo ti aiuta a ricercare e organizzare il materiale, ma ti guida anche nella scrittura. Il nostro sistema ti fornisce suggerimenti su come strutturare e migliorare la qualità del tuo lavoro.",
        },
        {
            question: "Come posso monitorare i miei progressi con Athena?",
            answer:
                "Nel tuo pannello di controllo, Athena tiene traccia dei tuoi progressi e ti mostra quanta parte della tesi hai completato. Puoi anche vedere se stai rispettando la tua roadmap e ricevere avvisi per non cadere nella procrastinazione.",
        },
        {
            question: "Athena è adatto per tutti i corsi di laurea?",
            answer:
                "Sì, Athena è progettato per essere utilizzato da studenti di tutti i corsi di laurea. Che tu stia scrivendo una tesi di ingegneria, medicina, lettere o scienze sociali, Athena offre strumenti e risorse per tutti i tipi di ricerca e scrittura accademica.",
        },
    ];

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index); // Toggle the question's visibility
    };

    return (
        <div className="flex flex-col w-full gap-3">
            {questionsAndAnswers.map((faq, index) => (
                <div
                    key={index}
                    className={`flex flex-col p-6 transition-all duration-300 ${openIndex === index ? "bg-white" : "bg-white"
                        } border-2 border-gray-100 rounded-[12px] cursor-pointer`}
                    onClick={() => handleToggle(index)}
                >
                    <div className="flex w-full justify-between items-center">
                        <Typography size="16" weight="sb">
                            {faq.question}
                        </Typography>
                        <div className={`transition-transform duration-300 ${openIndex === index ? "transform rotate-90" : ""}`}>
                            <ChevronRight size={20} color="#7D7C78" />
                        </div>
                    </div>
                    {openIndex === index && (
                        <div className="w-full mt-3 animate-slideDown">
                            <Typography size="12" desktopSize="16" weight="rg" color="gray-600">
                                {faq.answer}
                            </Typography>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FAQ;